import React from "react";
import { useTrans } from "../../hooks";
import OnboardingTooltip from "../home/components/OnboardingTooltip";

function SeriesOnboardingTooltip() {
  const { trans } = useTrans();

  return (
    <OnboardingTooltip
      title={trans("Create series")}
      text={trans(
        "Link your stories into a series to keep readers engaged from start to finish"
      )}
      className="series-onboarding-tooltip"
      showCloseButton
    />
  );
}

export default SeriesOnboardingTooltip;
